module.exports = __webpack_public_path__ + "static/media/ThereForYou.1941390e.svg";